import apiClient from './client'

export const examsApi = {
  getExams: async (params = {}) => {
    const response = await apiClient.get('/exams', { params })
    return response.data
  },

  getExamDetails: async (id) => {
    const response = await apiClient.get(`/exams/${id}/details`)
    return response.data
  },

  submitExam: async (id, answers) => {
    const response = await apiClient.post(`/exams/${id}/submit`, { answers })
    return response.data
  },

  getExamResult: async (id) => {
    const response = await apiClient.get(`/exams/${id}/result`)
    return response.data
  },
}

